import { useState } from "react";
import {
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { setFormModal } from "../redux/slices/modalSlice";
import { getTagSchema } from "../utils/formValidationSchema";
import httpRequest from "../utils/httpRequest";
import { BASE_URL } from "../config/settings";
// import { setgetTagDetails } from "../redux/slices/eventSlice";
// import { setloadTost } from "../redux/slices/toastSlice";

const GetReceipt = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  //   const [retryPaymentUrl, setRetryPaymentUrl] = useState("");
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [error, setError] = useState("");
  // const formModal = useSelector((state) => state.modal.formModal);
  // const eventId = formModal?.data;

  const initialValues = {
    reference: "",
    eventId: 0,
  };

  // const handleSubmit = async (values) => {
  //   setError("");
  //   setLoading(true);
  //   try {
  //     const formData = {
  //       Reference: values.reference,
  //       eventId: eventId,
  //     };
  //     const response = await httpRequest(
  //       `${BASE_URL}/Tag/generate-tag`,
  //       "post",
  //       formData
  //     );
  //     if (response?.isSuccessful === true) {
  //       setLoading(false);

  //       // dispatch(setFormModal({ status: false }));
  //       setSuccess(true);
  //       setSuccessMsg(
  //         //   response?.successMessage ||
  //         "Receipt generated successfully! \n Kindly check your email."
  //       );
  //       setTimeout(() => {
  //         dispatch(setFormModal({ status: false }));
  //       }, 3000);
  //     } else {
  //       setLoading(false);
  //       throw new Error(
  //         //   response?.response?.data?.responseDescription ||
  //         "Failed to generate receipt. Please try again later."
  //       );
  //     }
  //   } catch (error) {
  //     setError(error?.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (values) => {
    setError("");
    setLoading(true);
    setSuccess(false);

    try {
      const response = await httpRequest(
        `${BASE_URL}/Payment/generate-receipt/${values.reference}`,
        "get",
        null,
        {
          responseType: "blob", // to handle PDF
        }
      );

      const blob = new Blob([response], { type: "application/pdf" });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `receipt-${values.reference}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      setSuccess(true);
      setSuccessMsg(
        "Receipt generated and downloaded successfully!\n" +
          "Kindly check your email for the same receipt.\n" +
          "You can return to this page to regenerate receipts for your successful transactions at any time."
      );

      setTimeout(() => {
        dispatch(setFormModal({ status: false }));
      }, 5000);
    } catch (error) {
      setError(
        "Failed to generate or download receipt. Please check your reference and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {error && (
        <Alert status="error" mt={10}>
          <AlertIcon />
          <AlertTitle>{error}</AlertTitle>
        </Alert>
      )}
      {success && (
        <Alert status="success" mt={10}>
          <AlertIcon />
          {/* <AlertTitle>{successMsg}</AlertTitle> */}
          <Text whiteSpace="pre-line">{successMsg}</Text>
        </Alert>
      )}
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={getTagSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          //   setFieldValue,
        }) => (
          <Flex direction="column" rowGap={4} as={Form}>
            <FormControl
              mt={"50px"}
              isInvalid={errors.reference && touched.reference}
            >
              <FormLabel>Reference Number</FormLabel>
              <Input
                placeholder="Enter Here"
                fontSize={"small"}
                bg={"#F3F3F3"}
                name="reference"
                focusBorderColor="#ffffff"
                borderRadius={"0"}
                borderColor={"#FFFFFF"}
                _placeholder={{ color: "#B4B1B1" }}
                _hover={{ borderColor: "#FFFFFF" }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values?.reference}
              />
              {touched.reference && errors.reference && (
                <FormErrorMessage>{errors.reference}</FormErrorMessage>
              )}
            </FormControl>
            <Text fontSize={14} color={"#494949"} fontWeight={600}>
              Kindly check your email for required Reference Number!
            </Text>
            <Button
              mt={6}
              width={"100%"}
              background={"#22944E"}
              _hover={{ background: " " }}
              color={"#FFFFFF"}
              type="submit"
              isLoading={loading}
              loadingText="Loading..."
            >
              Generate Receipt
            </Button>
          </Flex>
        )}
      </Formik>
    </>
  );
};

export default GetReceipt;
